// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container {
  position: fixed;
  padding: 12px 16px;
  top: 22px;
  background: #8e8e8e;
  border-radius: 8px;
  left: 38.3%;
  width: 312px;
  z-index: 10;
  color: var(--white);
  display: flex;
  gap: 16px;
  left: calc(50% - 156px);
  align-items: center;
}
.toast-container h1 {
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.40799999237060547px;
  text-align: left;
}
.toast-container p {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07800000160932541px;
  text-align: left;
}
.toast-container img {
  height: 26px;
}
.toast-message {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/toast/toast.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV","sourcesContent":[".toast-container {\n  position: fixed;\n  padding: 12px 16px;\n  top: 22px;\n  background: #8e8e8e;\n  border-radius: 8px;\n  left: 38.3%;\n  width: 312px;\n  z-index: 10;\n  color: var(--white);\n  display: flex;\n  gap: 16px;\n  left: calc(50% - 156px);\n  align-items: center;\n}\n.toast-container h1 {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.40799999237060547px;\n  text-align: left;\n}\n.toast-container p {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: -0.07800000160932541px;\n  text-align: left;\n}\n.toast-container img {\n  height: 26px;\n}\n.toast-message {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
